import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PixStep1 from './PixStep1';
import PixStep2 from './PixStep2';
import PixStep3 from './PixStep3';

const PixMain = () => {
  return (
    <Routes>
      <Route path="/" element={<PixStep1 />} />
      <Route path="/step2" element={<PixStep2 />} />
      <Route path="/step3" element={<PixStep3 />} />
      <Route path="*" element={<Navigate to="/pix" replace />} />
    </Routes>
  );
};

export default PixMain;
